import { withRouter } from 'react-router-dom';
import React, { Component } from 'react';

import { OHIFLogo, OHIFLogoEn } from '../OHIFLogo/OHIFLogo.js';

import PropTypes from 'prop-types';
import { message, Button, Dropdown, Menu, Icon } from 'antd';
import { getCookie, EditInfoIcon, LogoutIcon, UserIcon } from '../../utils';
import { SoundOpenIcon, SoundCloseIcon, HelpSvgIcon } from '../../utils';
import { ArrowDownIcon, isIncluded } from '../../utils';
import i18n from 'i18next';
import EditPassword from './EditPassword.js';
import ConnectService from './ConnectService.js';
import AccountInfo from './AccountInfo.js';
import Notice from './Notice.js';
import WarmTip from './WarmTip.js';
import PwdTip from './PwdTip.js';
import './Header.css';
import _ from 'lodash';

import { apis } from '../../api/index.js';

class Header extends Component {
  static propTypes = {
    home: PropTypes.bool.isRequired,
    location: PropTypes.object.isRequired,
    children: PropTypes.node,
    login: PropTypes.bool,
    history: PropTypes.object,
    setSoundState: PropTypes.func,
    soundState: PropTypes.bool,
    changeMenuTaskFlag: PropTypes.any,
    newTaskStateObj: PropTypes.bool,
    setMenuCollapsedData: PropTypes.func,
    toggleCollapsed: PropTypes.func,
    serialNumber: PropTypes.any,
    onUserInfoUpdated: PropTypes.func,
    certIdShow: PropTypes.bool,
    applyToCertId: PropTypes.func,
    userInfo: PropTypes.object,
  };

  static defaultProps = {
    home: true,
    children: OHIFLogo(),
  };

  constructor(props) {
    super(props);
    this.state = {
      editPasswordVisible: false,
      collapsed: window.store.getState().api.current.menuCollapsed,
      showHelpState: false,
      editAccountVisible: false,
      serialNumber: '',
      tipsVisible: true,
      noticeVisible: false,
      noticeList: [],
      version: '2.3.1.220217_release',
    };

    this.audio = '';
  }
  toggleCollapsed1 = () => {
    this.setState({ collapsed: !this.state.collapsed });
    this.props.setMenuCollapsedData(!this.state.collapsed);
    this.props.toggleCollapsed(this.state.collapsed);
  };

  calcAudit(ids) {
    const { menus } = this.props.userInfo;
    let auditFlag = false;
    if (menus && menus.length > 0 && menus[0].childMenus.length > 0) {
      menus[0].childMenus.forEach(item => {
        if (item.id === ids[0]) {
          item.childMenus.forEach(atem => {
            if (atem.id === ids[1]) auditFlag = true;
          });
        }
      });
    }
    return auditFlag;
  }
  async componentDidMount() {
    this.getNoticeList();
    this.getLogo('zh-CN');
    this.checkLogin();
    this.initSoundState();

    const { pathname } = this.props.history.location;

    if (pathname === '/login') this.clearAllTime();

    if (pathname !== '/login' && pathname !== '/') {
      for (var i = 0; i < window['noticeInterval']; i++) {
        clearInterval(window['noticeInterval']);
      }
      this.noticeSlider();

      this.updatePwdTip();
    }

    const { userInfo } = this.props;
    const newState = _.pick(userInfo, ['certId', 'nickName']);
    this.onSetNewState(newState);
  }
  onSetNewState = newState => {
    this.setState({ ...newState });
  };
  getNoticeList = () => {
    const { pathname } = this.props.history.location;
    const isLoadSystemNotice = sessionStorage.getItem('isLoadSystemNotice');
    if (pathname !== '/login' && pathname !== '/') {
      apis.noticeList().then(res => {
        if (res.code === '0' && res.data.length > 0) {
          const list = res.data;
          const { version } = this.state;
          const noticeList = [];
          list.forEach(item => {
            if (item.version !== version) noticeList.push(item);
          });
          this.setState({
            noticeList,
            noticeVisible:
              isLoadSystemNotice === 'false' && noticeList.length > 0,
          });

          sessionStorage.setItem('isLoadSystemNotice', 'true');
        }
      });
    }
  };

  checkLogin = () => {
    if (!this.props.login) {
      const token = getCookie('userToken');
      const { nickName } = this.props.userInfo;
      if (!token || nickName === '') {
        message.warning('请先登录', 2);
        this.props.history.push('/login');
      } else {
        apis.getSerialNumber().then(result => {
          if (result.code === '0') this.setState({ serialNumber: result.data });
        });
      }
    }
  };

  updatePwdTip = () => {
    const { userInfo } = this.props;
    if (userInfo.needUpdatePwd) this.setState({ updatePwdTipVisible: true });
  };

  noticeSlider = () => {
    function ttb() {
      const div = document.getElementById('div1');
      const span = document.getElementById('span1');
      const span2 = document.getElementById('span2');
      if (div && span && span2) {
        span2.innerHTML = span.innerHTML;
        if (span.offsetWidth <= div.scrollLeft)
          div.scrollLeft -= span.offsetWidth;
        else div.scrollLeft++;
      }
    }
    window['noticeInterval'] = setInterval(ttb, 50);
  };
  clearAllTime() {
    for (var i = 0; i < window['tipTime']; i++) {
      clearInterval(window['tipTime']);
    }
  }
  componentDidUpdate(prevProps) {
    const { certIdShow } = this.props;
    if (certIdShow !== prevProps.certIdShow) {
      this.setState({ editAccountVisible: certIdShow });
    }
  }
  getLogo = currentLang => {
    this.setState({
      children: currentLang === 'en-US' ? OHIFLogoEn() : OHIFLogo(),
    });
  };

  logout = () => {
    apis.logout().then(result => {
      if (result.code === '0') {
        /*global _$x*/
        /*eslint no-undef: "error"*/
        if (typeof _$x === 'undefined') {
          message.success(i18n.t('successful'), 2);
          this.props.history.push('/login');
        } else _$x.ExitExe();
      } else {
        message.error(result.message, 2);
        if (result.code === '1009') this.history.push('/login');
      }
    });
    apis.logout4CT();
  };

  handlePasswordState = (state, noClose) => {
    this.setState({ editPasswordVisible: state, passwordNoClose: noClose });
  };

  showAccount = () => {
    this.setState({ editAccountVisible: true });
  };

  hideAccount = () => {
    this.setState({ editAccountVisible: false });
    if (this.props.applyToCertId) this.props.applyToCertId(false);
  };
  changeSoundState = () => {
    const { nickName } = this.props.userInfo;
    const soundState = !this.props.soundState;
    const soundStateObj = JSON.parse(localStorage.getItem('soundStateObj'));
    let storeMap = soundStateObj || [];
    let obj = { name: nickName, soundState };
    storeMap.forEach(item => {
      if (item.name === nickName) item.soundState = soundState;
    });
    storeMap.push(obj);
    storeMap = this.arrUnique(storeMap, 'name');
    localStorage.setItem('soundStateObj', JSON.stringify(storeMap));
    this.props.setSoundState(soundState);
  };
  arrUnique(arr, item) {
    let [a, b] = [[], {}];
    for (var i = 0; i < arr.length; i++) {
      if (item) {
        if (!b[arr[i][item]]) {
          a.push(arr[i]);
          b[arr[i][item]] = 1;
        }
      } else {
        if (!b[arr[i]]) {
          a.push(arr[i]);
          b[arr[i]] = 1;
        }
      }
    }
    return a;
  }

  initSoundState() {
    const { nickName } = this.props.userInfo;
    const soundStateObj = JSON.parse(localStorage.getItem('soundStateObj'));
    let storeMap = soundStateObj ? soundStateObj : [];

    let oldSoundState = true;
    storeMap.forEach(item => {
      if (item.name === nickName) oldSoundState = item.soundState;
    });
    const sound = storeMap.some(item => {
      return item.name === nickName;
    });
    oldSoundState = sound ? oldSoundState : true;
    this.props.setSoundState(oldSoundState);
    return oldSoundState;
  }
  initTipVisible() {
    const { nickName } = this.props.userInfo;
    const tipsVisible = JSON.parse(localStorage.getItem('tipsVisible'));
    let storeMap = tipsVisible ? tipsVisible : [];

    let oldSoundState = true;
    storeMap.forEach(item => {
      if (item.name === nickName) oldSoundState = item.tipsVisible;
    });
    const sound = storeMap.some(item => {
      return item.name === nickName;
    });
    oldSoundState = sound ? oldSoundState : true;
    return oldSoundState;
  }
  showHelp() {
    this.setState({ showHelpState: true });
  }

  onWarmTipCancel = () => {
    this.setState({ tipsVisible: false });
    sessionStorage.setItem('isLoadTips', 'true');
  };

  getMenu = () => {
    return (
      <Menu>
        <Menu.Item key="1" onClick={() => this.handlePasswordState(true)}>
          <EditInfoIcon />
          修改密码
        </Menu.Item>
        <Menu.Item key="2" onClick={this.showAccount}>
          <Icon type="clock-circle" />
          账户信息
        </Menu.Item>
        <Menu.Item key="3" onClick={this.logout}>
          <LogoutIcon />
          退出账户
        </Menu.Item>
      </Menu>
    );
  };
  getRightCnt = () => {
    let oldSoundState = this.initSoundState();
    const { userInfo } = this.props;
    const authOpt = (userInfo.operationAuths || '').split(',');
    let showSound = false;
    const calc1 = this.calcAudit([16, 28]); // 智能筛查审核：待审核
    const calc2 = this.calcAudit([18, 19]); // 远程诊断报告：待报告、待审核
    const calc3 = this.calcAudit([18, 54]);
    if (calc1 || (isIncluded(['T', 'M', 'Q'], authOpt) && (calc2 || calc3)))
      showSound = true;
    return (
      <>
        <Button className="head-dropdown" onClick={this.showHelp.bind(this)}>
          <HelpSvgIcon />
          联系客服
        </Button>
        {showSound && (
          <Button
            className="head-dropdown"
            onClick={this.changeSoundState.bind(this)}
          >
            {oldSoundState ? <SoundOpenIcon /> : <SoundCloseIcon />}
            提示音
          </Button>
        )}

        <Dropdown overlay={this.getMenu()} placement="topRight">
          <Button className="head-dropdown">
            <UserIcon />
            {this.state.nickName}
            <ArrowDownIcon className="arrow-down" />
          </Button>
        </Dropdown>
      </>
    );
  };

  render() {
    let tipVisibleState = this.initTipVisible();
    const { pathname } = window.location;
    const pPathname = this.props.history.location.pathname;
    const { noticeList, noticeVisible } = this.state;
    const notice = noticeList[0] || {};

    const { login, home } = this.props;

    const noticeContent = _.replace(notice.content, /<br\/>/g, '');

    const isLoadTips = sessionStorage.getItem('isLoadTips') !== 'true';
    return (
      <div className={`entry-header ${home ? 'header-big' : 'header-small'}`}>
        <div className="header-left-box">
          {!login && (
            <Icon
              onClick={this.toggleCollapsed1}
              type={this.state.collapsed ? 'menu-unfold' : 'menu-fold'}
            />
          )}
          {!login && noticeVisible === false && notice.title && (
            <div className="notice-slider-box">
              <Icon type="bell" theme="filled" />
              <div id="div1" className="notice-slider">
                <span id="span1">{noticeContent}</span>
                <span id="span2"></span>
              </div>
            </div>
          )}
        </div>
        <div className="header-right-box">{!login && this.getRightCnt()}</div>
        <EditPassword
          visible={this.state.editPasswordVisible}
          passwordNoClose={this.state.passwordNoClose}
          onCancel={() => this.handlePasswordState(false)}
          userInfo={this.props.userInfo}
          onUserInfoUpdated={this.props.onUserInfoUpdated}
        />
        <ConnectService
          visible={this.state.showHelpState}
          onCancel={() => this.setState({ showHelpState: false })}
        />
        <AccountInfo
          visible={this.state.editAccountVisible}
          onCancel={this.hideAccount}
          onSetNewState={this.onSetNewState}
          {...this.state}
          {...this.props}
        />
        <Notice
          visible={this.state.noticeVisible}
          onCancel={() => this.setState({ noticeVisible: false })}
          notice={notice}
        />

        {tipVisibleState &&
          !(
            pathname.includes('/heatmap') || pathname.includes('/viewer/study')
          ) &&
          pPathname !== '/login' &&
          pPathname !== '/' &&
          isLoadTips && (
            <WarmTip
              visible={this.state.tipsVisible}
              onCancel={this.onWarmTipCancel}
              {...this.props}
              arrUnique={this.arrUnique}
            />
          )}
        <PwdTip
          visible={this.state.updatePwdTipVisible || false}
          onCancel={() => this.setState({ updatePwdTipVisible: false })}
          {...this.props}
          handlePasswordState={this.handlePasswordState}
        />
      </div>
    );
  }
}

export default withRouter(Header);
